'use client';

import { useTranslations } from 'next-intl';
import { ComponentPropsWithoutRef, useContext } from 'react';

import { cn } from '@/shared/lib/cn';
import { useSelectedCurrency } from '@/shared/lib/hooks/useSelectedCurrency';

import { Card } from '@/shared/ui/card';
import { Form } from '@/shared/ui/form';
import { InputRow } from '@/shared/ui/input-row';
import { ModalService } from '@/shared/ui/modal/ModalService';
import './cart-top-up-box.scss';

import { useCartStore, CartContext, getPriceValueTranslation } from '@/entities/cart';

type Props = ComponentPropsWithoutRef<typeof Card>;
export const CartTopUpBox = (props: Props) => {
    const t = useTranslations();
    const { formMethods } = useContext(CartContext);
    const [selectedCurrency] = useSelectedCurrency();
    const topUpFee = useCartStore((s) => s.topUpFee);

    if (!topUpFee) {
        return null;
    }

    return (
        <Card {...props} className={cn('cart-top-up-box', props.className)}>
            <h3 className="cart-top-up-box__title" data-testid="cart-top-up-box-title">
                {t('CART_TOP_UP_BOX.TITLE', {
                    amount: getPriceValueTranslation({
                        t,
                        amount: topUpFee,
                        currency: selectedCurrency,
                    }),
                })}
            </h3>
            <Form.RadioGroup
                name="topUpOption"
                className="cart-top-up-box__radio-group"
                onValueChange={(value) => {
                    if (value === 'select-more') {
                        ModalService.showPrefab('TopUpOrderModal', {});
                        formMethods.setValue('topUpOption', 'pay');
                    }
                }}
            >
                {({ value }) => (
                    <>
                        <InputRow
                            as={Form.RadioGroup.Item}
                            value="pay"
                            className="cart-top-up-box__option"
                            isActive={value === 'pay'}
                            data-testid="cart-top-up-box-pay-option"
                        >
                            <Form.RadioGroup.Indicator />
                            <span data-testid="cart-top-up-box-pay-label">
                                {t('CART_TOP_UP_BOX.PAY_OPTION')}
                            </span>
                            <span className="cart-top-up-box__price" data-testid="cart-top-up-box-pay-price">
                                {getPriceValueTranslation({
                                    t,
                                    amount: topUpFee,
                                    currency: selectedCurrency,
                                })}
                            </span>
                        </InputRow>
                        {/*<InputRow
                            as={Form.RadioGroup.Item}
                            value="select-more"
                            className="cart-top-up-box__option"
                            isActive={value === 'select-more'}
                            data-testid="cart-top-up-box-select-more-option"
                        >
                            <Form.RadioGroup.Indicator />
                            <span data-testid="cart-top-up-box-select-more-label">
                                {t('CART_TOP_UP_BOX.SELECT_MORE_OPTION')}
                            </span>
                        </InputRow>*/}
                    </>
                )}
            </Form.RadioGroup>
        </Card>
    );
};
